@if ((gallery?.enabled_asset_statuses | galleryIsApproveOnly) || displayOnly) {
  <button
    appButton
    [name]="asset.status === 'approved' ? 'no_status_only' : 'approved_only'"
    [analyticsExtra]="{ status: asset.status === 'approved' ? 'no_status' : 'approved' }"
    [location]="location"
    [hasIcon]="!small"
    [iconButton]="small"
    [color]="asset.status === 'approved' ? 'green' : defaultColor"
    iconTextSpacing="0"
    shape="round"
    [height]="tiny ? '-1' : advancedMode ? '0' : '1'"
    [spacing]="tiny ? '1' : undefined"
    [size]="tiny ? '-1' : '1'"
    weight="bold"
    [class.display-only]="displayOnly"
    (click)="onSelectStatus.emit(asset.status === 'approved' ? 'no_status' : 'approved')"
    [appTooltip]="displayOnly ? undefined : asset.status === 'approved' ? 'Unapprove' : 'Approve'"
  >
    <app-svg src="/assets/icons/check-outline.svg" [attr.size]="tiny ? '0' : advancedMode ? '0' : undefined"></app-svg>
    @if (!small) {
      <div class="approved-parent">
        @if (asset.status === 'approved') {
          <span>Approved</span>
        }
        @if (asset.status !== 'approved') {
          <span>Approve</span>
        }
        @if (gallery?.approval_limits && !advancedMode) {
          <div class="approval-limit">
            {{ approvedAssetCount }} {{ 'of' | translate }} {{ gallery?.approval_limits | abs }}
          </div>
        }
      </div>
    }
  </button>
} @else {
  @if (asset.status === 'no_status' && !small) {
    <div class="combined-buttons" [class.tiny]="advancedMode" [class.small]="!advancedMode">
      <button
        class="first-combined"
        appButton
        name="asset-status"
        [analyticsExtra]="{ status: 'approved' }"
        [location]="location"
        [hasIcon]="true"
        [color]="defaultColor"
        iconTextSpacing="0"
        shape="round"
        [height]="tiny ? '-1' : advancedMode ? '-2' : '1'"
        [size]="advancedMode ? '-1' : '1'"
        [spacing]="tiny ? '1' : undefined"
        weight="bold"
        (click)="onSelectStatus.emit('approved')"
        [appTooltip]="'Approve'"
        [tooltipKeyboardShortcut]="'A'"
      >
        <app-svg
          src="/assets/icons/check-outline.svg"
          [attr.size]="tiny ? '0' : advancedMode ? '-1' : undefined"
        ></app-svg>
        <div class="approved-parent">
          <span>Approve</span>
          @if (gallery?.approval_limits && !advancedMode) {
            <div class="approval-limit">
              {{ approvedAssetCount }} {{ 'of' | translate }} {{ gallery?.approval_limits | abs }}
            </div>
          }
        </div>
      </button>
      <app-context-menu
        [options]="{ width: '240px', noSpacing: true }"
        contextHoverIdentifier="asset-{{ asset.id }}"
        position="right"
        #statusMenu
      >
        <button
          appButton
          name="asset-status-more"
          [location]="location"
          [iconButton]="true"
          [color]="defaultColor"
          shape="round"
          [height]="tiny ? '-1' : advancedMode ? '-2' : '1'"
          [spacing]="tiny ? '1' : undefined"
          [size]="advancedMode ? '-1' : '1'"
          class="last-combined"
          contextButton
          [appTooltip]="'change-asset-status-tooltip' | translate"
        >
          <div class="separator"></div>
          <app-svg
            [src]="'/assets/icons/' + (advancedMode || tiny ? 16 : 18) + '/chevron-down.svg'"
            [attr.size]="tiny ? '-2' : advancedMode ? '-1' : '-0-5'"
            [class.move-chevron-left]="tiny"
          ></app-svg>
        </button>
        <div class="button-menu" contextContent>
          <app-asset-status-button-extra-context
            [gallery]="gallery"
            [currentStatus]="asset.status"
            [location]="location"
            (onSelectStatus)="onSelectStatus.emit($event); statusMenu.close()"
          ></app-asset-status-button-extra-context>
        </div>
      </app-context-menu>
    </div>
  }
  @if (asset.status !== 'no_status' || small) {
    <app-context-menu
      [options]="{ width: '240px', noSpacing: true }"
      contextHoverIdentifier="asset-{{ asset.id }}"
      #statusMenu
    >
      <button
        appButton
        name="asset-status"
        [analyticsExtra]="{ status: 'no_status' }"
        [location]="location"
        [hasIcon]="!advancedMode"
        [iconButton]="advancedMode"
        [color]="(asset.status | assetStatusButtonColor: true) || defaultColor"
        iconTextSpacing="0"
        shape="round"
        [height]="tiny ? '-1' : advancedMode ? '0' : '1'"
        [spacing]="tiny ? '1' : undefined"
        [size]="tiny ? '-1' : '1'"
        weight="bold"
        contextButton
        [appTooltip]="'change-asset-status-tooltip' | translate"
      >
        <app-svg
          [src]="
            '/assets/icons/' +
            (small && asset.status === 'no_status' ? 'mixed-status' : (asset.status | assetStatusIcon)) +
            '.svg'
          "
          [attr.size]="tiny ? '0' : advancedMode ? '0' : undefined"
        ></app-svg>
        @if (!small) {
          <div class="approved-parent">
            <span>{{ asset.status | assetStatusName }}</span>
            @if (gallery?.approval_limits && asset.status === 'approved' && !advancedMode) {
              <div class="approval-limit">
                {{ approvedAssetCount }} {{ 'of' | translate }} {{ gallery?.approval_limits | abs }}
              </div>
            }
          </div>
        }
        @if (!advancedMode) {
          <app-svg
            [src]="'/assets/icons/' + (advancedMode || tiny ? 16 : 18) + '/chevron-down.svg'"
            [attr.size]="tiny ? '-2' : advancedMode ? '-1' : '-0-5'"
            [class.move-chevron-left]="tiny"
          ></app-svg>
        }
      </button>
      <div class="button-menu" contextContent>
        <app-asset-status-button-extra-context
          [gallery]="gallery"
          [currentStatus]="asset.status"
          [location]="location"
          (onSelectStatus)="onSelectStatus.emit($event); statusMenu.close()"
        ></app-asset-status-button-extra-context>
      </div>
    </app-context-menu>
  }
}
